<template>
  <div class="content">
    <img src="img/comprovante.jpg" />
  </div>
</template>
<script>
export default {};
</script>
<style>
</style>
